/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Duration } from './';
import {
    DurationFromJSON,
    DurationFromJSONTyped,
    DurationToJSON,
} from './';
import type { JobTitle } from './';
import {
    JobTitleFromJSON,
    JobTitleFromJSONTyped,
    JobTitleToJSON,
} from './';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';
import type { ProjectDescription } from './';
import {
    ProjectDescriptionFromJSON,
    ProjectDescriptionFromJSONTyped,
    ProjectDescriptionToJSON,
} from './';
import type { ProjectTitle } from './';
import {
    ProjectTitleFromJSON,
    ProjectTitleFromJSONTyped,
    ProjectTitleToJSON,
} from './';
import type { Skill } from './';
import {
    SkillFromJSON,
    SkillFromJSONTyped,
    SkillToJSON,
} from './';
import type { StartDate } from './';
import {
    StartDateFromJSON,
    StartDateFromJSONTyped,
    StartDateToJSON,
} from './';
import type { WorkConditions } from './';
import {
    WorkConditionsFromJSON,
    WorkConditionsFromJSONTyped,
    WorkConditionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubmitProposalRequest
 */
export interface SubmitProposalRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmitProposalRequest
     */
    resumeBriefId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubmitProposalRequest
     */
    profileIds: Array<string>;
    /**
     * 
     * @type {Origin}
     * @memberof SubmitProposalRequest
     */
    origin: Origin;
    /**
     * 
     * @type {string}
     * @memberof SubmitProposalRequest
     */
    searchId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitProposalRequest
     */
    profileViewId?: string;
    /**
     * 
     * @type {JobTitle}
     * @memberof SubmitProposalRequest
     */
    jobTitle: JobTitle;
    /**
     * 
     * @type {ProjectTitle}
     * @memberof SubmitProposalRequest
     */
    projectTitle: ProjectTitle;
    /**
     * 
     * @type {StartDate}
     * @memberof SubmitProposalRequest
     */
    startDate: StartDate;
    /**
     * 
     * @type {Duration}
     * @memberof SubmitProposalRequest
     */
    duration: Duration;
    /**
     * 
     * @type {WorkConditions}
     * @memberof SubmitProposalRequest
     */
    workConditions: WorkConditions;
    /**
     * 
     * @type {ProjectDescription}
     * @memberof SubmitProposalRequest
     */
    description: ProjectDescription;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof SubmitProposalRequest
     */
    skills: Array<Skill>;
}

/**
 * Check if a given object implements the SubmitProposalRequest interface.
 */
export function instanceOfSubmitProposalRequest(value: object): value is SubmitProposalRequest {
    if (!('profileIds' in value) || value['profileIds'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('jobTitle' in value) || value['jobTitle'] === undefined) return false;
    if (!('projectTitle' in value) || value['projectTitle'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('workConditions' in value) || value['workConditions'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('skills' in value) || value['skills'] === undefined) return false;
    return true;
}

export function SubmitProposalRequestFromJSON(json: any): SubmitProposalRequest {
    return SubmitProposalRequestFromJSONTyped(json, false);
}

export function SubmitProposalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitProposalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'resumeBriefId': json['resumeBriefId'] == null ? undefined : json['resumeBriefId'],
        'profileIds': json['profileIds'],
        'origin': OriginFromJSON(json['origin']),
        'searchId': json['searchId'] == null ? undefined : json['searchId'],
        'profileViewId': json['profileViewId'] == null ? undefined : json['profileViewId'],
        'jobTitle': JobTitleFromJSON(json['jobTitle']),
        'projectTitle': ProjectTitleFromJSON(json['projectTitle']),
        'startDate': StartDateFromJSON(json['startDate']),
        'duration': DurationFromJSON(json['duration']),
        'workConditions': WorkConditionsFromJSON(json['workConditions']),
        'description': ProjectDescriptionFromJSON(json['description']),
        'skills': ((json['skills'] as Array<any>).map(SkillFromJSON)),
    };
}

export function SubmitProposalRequestToJSON(value?: SubmitProposalRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'resumeBriefId': value['resumeBriefId'],
        'profileIds': value['profileIds'],
        'origin': OriginToJSON(value['origin']),
        'searchId': value['searchId'],
        'profileViewId': value['profileViewId'],
        'jobTitle': JobTitleToJSON(value['jobTitle']),
        'projectTitle': ProjectTitleToJSON(value['projectTitle']),
        'startDate': StartDateToJSON(value['startDate']),
        'duration': DurationToJSON(value['duration']),
        'workConditions': WorkConditionsToJSON(value['workConditions']),
        'description': ProjectDescriptionToJSON(value['description']),
        'skills': ((value['skills'] as Array<any>).map((v) => SkillToJSON(v))),
    };
}

